import React,{ useState, useEffect } from "react"
import axios from "axios"
import { useNavigate } from "react-router-dom"
import baseURL from "../Url/Url.jsx"

const LupaPassword = () => {
    const [userName, setUserName] = useState("")
    const [ktp, setKtp] = useState("")
    const [namaLengkap, setNamaLengkap] = useState("")
    const [password, setPassword] = useState('')
    const [confPassword, setConfPassword] = useState('')
    const [msg, setMsg] = useState("")
    const [displayLoader, setDisplayLoader] = useState("")
    const navigate = useNavigate()

    useEffect(()=>{
        setDisplayLoader("none")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // lupa password
    const lupaPassword = async(e)=>{
        e.preventDefault()
        try {
            setDisplayLoader("")
            await axios.post(`${baseURL}/lupaPasswordBE`,{
                userName: userName,
                ktp: ktp,
                namaLengkap: namaLengkap,
                password: password,
                confPassword: confPassword
            })
            navigate("/", { replace: true })
        } catch (error) {
            if(error.response){
                setDisplayLoader("none")
                setMsg(error.response.data.msg)
            }
        }
    }

    // Halaman
    return (
        <div>
            <div className="loader-page-bg" style={{display:displayLoader}}>
                <div className="loader-page"></div>
            </div>
            
            <div className="container mb-3" style={{marginTop:"68px"}}>
                <div className="row justify-content-center">
                    <div className="col-11 col-sm-10 col-md-8 col-lg-7 col-xl-6">
                        <div className="box-login" style={{marginTop:"35px"}}> 
                            <h4 className="text-center" style={{fontWeight:"700"}}>Buat Password Baru</h4>
                            <form onSubmit={lupaPassword}>
                                <h6 style={{textAlign:"center",marginTop:"15px",marginBottom:"-10px",color:"red"}}>{msg}</h6>
                                <label htmlFor="userName" className="mx-2"></label>
                                <input type="text" id="userName" className="form-control form mb-3" placeholder="Masukan username" value={userName} onChange={(e) => setUserName(e.target.value)} autoFocus required/>
                                <div className="row justify-content-center">
                                    <div className='col-12 col-sm-6'>
                                        <input type="number" id="ktp" className="form-control form mb-3 mt-4" placeholder="Masukan KTP Anda" value={ktp} onChange={(e) => setKtp(e.target.value)} required/>
                                    </div>
                                    <div className='col-12 col-sm-6'>
                                        <input type="text" id="namaLengkap" className="form-control form mb-3 mt-4" placeholder="Masukan Nama Lengkap Anda" value={namaLengkap} onChange={(e) => setNamaLengkap(e.target.value)} required/>
                                    </div>
                                    <div className='col-12 col-sm-6'>
                                        <input type='password' id='password' className='form-control form mb-3 mt-4' placeholder='Buat password baru' value={password} onChange={(e) => setPassword(e.target.value)} required/>
                                    </div>
                                    <div className='col-12 col-sm-6'>
                                        <input type='password' id='confPassword' className='form-control form mb-3 mt-4' placeholder='Ulangi password' value={confPassword} onChange={(e) => setConfPassword(e.target.value)} required/>
                                    </div>
                                </div>
                                <input type="submit" className="btn btn-webew-login mb-4 mt-3" value="Proses"/>
                                <a href="/" style={{color:"rgb(0, 86, 247)", margin:"auto", display:"block", textAlign:"center", fontSize:"11pt"}}>Sudah ingat Password ?</a>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LupaPassword